export default "__VITE_ASSET__69kzr1Qh__"